import { buildRequestToParams } from "../../applications/utils/StringUtils";
import { ApiClient } from "../api/ApiClient";
import {
  CreateOperatingCostRequest,
  FilterOperatingCostRequest,
} from "../model/OperatingCostModel";
import { OperatingCostModel } from "./../model/OperatingCostModel";

const BASE_ULR = "/api/operating-costs";

class OperatingCostServiceClass {
  getListOperatingCost(request: FilterOperatingCostRequest) {
    const params = buildRequestToParams(request);
    return ApiClient.get<OperatingCostModel[]>(BASE_ULR + `?${params}`);
  }

  createOperatingCost(request: CreateOperatingCostRequest) {
    return ApiClient.post<OperatingCostModel>(BASE_ULR, request);
  }

  deleteOperatingCost(id: number) {
    return ApiClient.delete(BASE_ULR + `/${id}`);
  }
}

const OperatingCostService = new OperatingCostServiceClass();
export default OperatingCostService;
